/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import {
  Layout,
  Spin,
  Col, Row,
} from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import { FormikProvider, useFormik } from 'formik';
import { Form, Select, Checkbox } from 'formik-antd';
import { useStore } from '../../../../store';
import FormControl from '../../../lib/form-control';
import PrimaryButton from '../../../lib/primary-button';
import handleField from '../../../../utils/handle-field';
import { useActions } from '../../../providers/actions-provider/actions.context';
import { ReactComponent as ThrashCan } from '../../../../assets/icons/thrashCan.svg';
import NewProperty from '../../../lib/new-property';
import PageTitle from '../../../lib/page-title';
import DeleteModal from '../../../lib/delete-modal/delete-modal';
import checkPermission from '../../../../utils/permissions/permissions';

const SchemaEditor = (): JSX.Element => {
  const { pathname } = useLocation();
  const property = pathname.split('/').splice(-2, 2).pop() || '';
  const { Option } = Select;
  const [isEditable, setIsEditable] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const { tenantActions } = useActions();
  const { goBack } = useHistory();
  const {
    wrappedSchema,
    tenantProperties,
  } = useStore();
  const onSubmit = (values: any) => {
    tenantActions.updateSchemaProperty(wrappedSchema.data, values);
  };
  const wrappedSchemaFormik = useFormik({
    initialValues: {
      fieldsTable: wrappedSchema.data.fields || [{
        allowNull: false, doc: '', isArray: false, name: '', type: '', values: null,
      }],
      readOnly: wrappedSchema.data.readOnly,
      newFieldsTable: [],
      editedFieldsTable: [],
      deletedFieldsTable: [],
    },
    enableReinitialize: true,
    validate: () => ({}),
    onSubmit: (values) => onSubmit(values),
  });
  const {
    values,
    setFieldValue,
    touched: wrapperPropertyTouched,
    setFieldTouched: setWrapperPropertyTouched,
    handleSubmit: handleReadersSubmit,
  } = wrappedSchemaFormik;
  // eslint-disable-next-line @typescript-eslint/no-shadow
  const deleteField = (values: any[], field: {name:string}) : typeof values => values.filter(((item) => item.name !== field.name));
  const getOptions = () => {
    const options = [];
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (const key in tenantProperties.data) {
      options.push({ value: key });
    }
    return options;
  };
  const schemaProperties = tenantProperties.loaded && getOptions();
  useEffect(() => {
    tenantActions.getTenantProperties();
    tenantActions.getSchemaProperty(property);
  }, []);
  useEffect(() => {
    if (tenantProperties.loaded) {
      setIsEditable(tenantProperties.loaded && tenantProperties.data[property] && tenantProperties.data[property].permissions === 'rw');
    }
  }, [tenantProperties]);
  return (
    <Layout className="main-container">
      {deleteModalVisible && (
        <DeleteModal
          text="Property"
          modalVisible={deleteModalVisible}
          onConfirm={() => {
            tenantActions.removeProperty(`schema.${property}`);
            setDeleteModalVisible(false);
            goBack();
          }}
          onCancel={() => setDeleteModalVisible(false)}
        />
      )}
      <PageTitle title={property} back>
        { checkPermission('datamodel', 'write') && (
          <PrimaryButton
            disabled={!isEditable}
            title="Delete Model"
            onClick={() => {
              setDeleteModalVisible(true);
            }}
          />
        )}
      </PageTitle>
      { !wrappedSchema.loaded || !schemaProperties ? <Spin /> : (
        <FormikProvider value={wrappedSchemaFormik}>
          <>
            <Row gutter={24}>
              <Col className="gutter-row" span={5}>
                <div className="ant-col ant-form-item-label form-control__label name">
                  Name
                </div>
              </Col>
              <Col className="gutter-row" span={5}>
                <div className="ant-col ant-form-item-label form-control__label type">
                  Type
                </div>
              </Col>
              <Col className="gutter-row" span={3}>
                <div className="ant-col ant-form-item-label form-control__label allownull">
                  Allow Null
                </div>
              </Col>
              <Col className="gutter-row" span={3}>
                <div className="ant-col ant-form-item-label form-control__label isarray">
                  Is Array
                </div>
              </Col>
              <Col className="gutter-row" span={3}>
                <div className="ant-col ant-form-item-label form-control__label values">
                  Values
                </div>
              </Col>
              <Col className="gutter-row" span={3}>
                <div className="ant-col ant-form-item-label form-control__label doc">
                  Description
                </div>
              </Col>
              <Col className="gutter-row" span={1} />
            </Row>
          </>
          <div className="data-model__wrapper">
            {
              // eslint-disable-next-line max-len
              values.fieldsTable.map((field: { isNew: boolean; type: string; name: string; allowNull: boolean; isArray: boolean; values: any; doc: string; }, i: number) => {
                const isEnum = field.type === 'enum';
                const valuesValue = isEnum
                    && field.values !== null && Array.isArray(field.values) ? Object.values(field.values).map((val: any) => `${val.value}`).join('\n') : '';
                return (
                  <div key={`reader=${i}`} className="data-model__plain-input data-model__plain-input--relative data-model__field">
                    <Row gutter={[0, 0]}>
                      <Col span={5}>
                        <FormControl
                          wrapperClassName="data-model__input"
                          inputClassName="formik-form__input"
                          name={`fieldsTable[${i}].name`}
                          disabled={!isEditable}
                          onChange={(input) => {
                            setFieldValue('editedFieldsTable', handleField(values.editedFieldsTable, { ...field, name: input.target.value }));
                            setWrapperPropertyTouched(`fieldsTable[${i}]`);
                          }}
                          label=""
                          type="text"
                        />
                      </Col>
                      <Col span={5}>
                        <Form.Item
                          name={`fieldsTable[${i}].type`}
                          label=""
                          className="data-model__input data-model__select"
                        >
                          <Select
                            size="large"
                            disabled={!isEditable}
                            defaultValue={field.type}
                            name={`fieldsTable[${i}].type`}
                            onChange={(val) => {
                              setFieldValue('editedFieldsTable', handleField(values.editedFieldsTable, { ...field, type: val }));
                              setWrapperPropertyTouched(`fieldsTable[${i}]`);
                            }}
                          >
                            <Select.Option value="string">string</Select.Option>
                            <Select.Option value="long">long</Select.Option>
                            <Select.Option value="double">double</Select.Option>
                            <Select.Option value="enum">enum</Select.Option>
                            {schemaProperties.map((el) => <Option key={el.value} value={el.value}>{el.value}</Option>)}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={3}>
                        <Form.Item
                          name={`fieldsTable[${i}].allowNull`}
                          label=""
                          className="data-model__checkbox"
                        >
                          <Checkbox
                            checked={field.allowNull}
                            disabled={field.isArray || field.type === 'enum' || !isEditable}
                            name={`fieldsTable[${i}].allowNull`}
                            onChange={(val) => {
                              setFieldValue('editedFieldsTable', handleField(values.editedFieldsTable, { ...field, allowNull: val.target.checked }));
                              setWrapperPropertyTouched(`fieldsTable[${i}]`);
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={3}>
                        <Form.Item
                          name={`fieldsTable[${i}].isArray`}
                          label=""
                          className="data-model__checkbox"
                        >
                          <Checkbox
                            checked={field.isArray}
                            name={`fieldsTable[${i}].isArray`}
                            disabled={field.allowNull || field.type === 'enum' || !isEditable}
                            onChange={(val) => {
                              setFieldValue('editedFieldsTable', handleField(values.editedFieldsTable, { ...field, isArray: val.target.checked }));
                              setWrapperPropertyTouched(`fieldsTable[${i}]`);
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={3}>
                        <Form.Item
                          name={`fieldsTable[${i}].values`}
                          label=""
                          className="data-model__textarea"
                        >
                          {isEnum
                            ? (
                              <FormControl
                                inputClassName="formik-form__input"
                                name={`fieldsTable[${i}].values`}
                                disabled={!isEditable}
                                value={valuesValue}
                                style={{ height: 70, resize: 'none', width: '200px' }}
                                onChange={(input) => {
                                  const tmpValues = [];
                                  if (input.target.value) {
                                    const arrayValues = input.target.value.split('\n');
                                    // eslint-disable-next-line no-plusplus
                                    for (let j = 0; j < arrayValues.length; j++) {
                                      const val = arrayValues[j];
                                      tmpValues.push({ key: val, value: val });
                                    }
                                  }
                                  setWrapperPropertyTouched(`fieldsTable[${i}]`);
                                }}
                                type="textarea"
                                label=""
                              />
                            )
                            : (valuesValue === '' ? <strong>N/A</strong> : '')}
                        </Form.Item>
                      </Col>
                      <Col span={3}>
                        <FormControl
                          inputClassName="formik-form__textarea"
                          name={`fieldsTable[${i}].doc`}
                          disabled={!isEditable}
                          style={{
                            width: '300px', resize: 'none',
                          }}
                          onChange={(input) => {
                            setFieldValue('editedFieldsTable', handleField(values.editedFieldsTable, { ...field, doc: input.target.value }));
                            setWrapperPropertyTouched(`fieldsTable[${i}]`);
                          }}
                          label=""
                          type="textarea"
                        />
                      </Col>
                      <Col span={1}>
                        <button
                          className="data-model__plain-input__delete"
                          type="button"
                          disabled={!isEditable}
                          onClick={() => {
                            setWrapperPropertyTouched(`fieldsTable[${i}]`);
                            const allFields = deleteField(values.fieldsTable, field);
                            if (field.isNew) {
                              setFieldValue('newFieldsTable', deleteField(values.newFieldsTable, field));
                            } else {
                              setFieldValue('editedFieldsTable', deleteField(values.editedFieldsTable, field));
                              setFieldValue('deletedFieldsTable', handleField(values.deletedFieldsTable, field));
                            }
                            setFieldValue('fieldsTable', allFields);
                          }}
                        >
                          {!isEditable ? '' : <ThrashCan />}
                        </button>
                      </Col>
                    </Row>
                  </div>
                );
              })
            }
            <div>
              { !isEditable ? '' : (
                <NewProperty
                  onClick={() => {
                    setFieldValue('newFieldsTable', [...values.newFieldsTable, {
                      allowNull: true, doc: '', isArray: false, name: '', type: '', values: null,
                    }]);
                    setFieldValue('fieldsTable', [...values.fieldsTable, {
                      allowNull: true, doc: '', isArray: false, name: '', type: '', values: null,
                    }]);
                  }}
                  title="New property"
                  disabled={!isEditable}
                />
              )}
            </div>
          </div>
          <PrimaryButton
            className="data-model__submit-btn asset-form__submit"
            disabled={!wrappedSchema.loaded
                || Boolean(!wrapperPropertyTouched.fieldsTable) || !isEditable}
            onClick={() => handleReadersSubmit()}
            title="Save"
          />
        </FormikProvider>
      )}
    </Layout>
  );
};

export default SchemaEditor;
